import { environment } from "../../environments/environment"
export const URLS ={
    COURSE_LIBRARY_LAUNCH_API: `${environment.platformApiURL}/static/course-library-launch.html`,
    OIDC_INITIATE_API:`${environment.platformApiURL}/oidc/initiate`,
    LOGIN_API:`${environment.platformApiURL}/platform-managers/login`,
    CHANGE_PASSWORD_API:`${environment.platformApiURL}/platform-managers/change-password`,
    TOOLS_API:`${environment.platformApiURL}/tools`,
    SHELL_COURSES_API:`${environment.platformApiURL}/shell-courses`,
    DUENDE_CLIENT_API:`${environment.platformApiURL}/duende-client`,
    DEEPLINKING_CONTENT_API:`${environment.platformApiURL}/deeplink`,
    
    LESSONS_API:`${environment.platformApiURL}/lessons`,
    GET_LESSON_CONTENT_ITEMS_COUNT_API:`${environment.platformApiURL}/lessons-and-tools-mapping/contentItems/count`,
    GET_LESSON_CONTENT_ITEMS_API:`${environment.platformApiURL}/lessons-and-tools-mapping/contentItems`,
    GET_TOOL_MAPPED_TO_COURSE_API :`${environment.platformApiURL}/lessons-and-tools-mapping/tool`,
    
    LINE_ITEMS_API:`${environment.platformApiURL}/ags-bff/lineitems`,
    GRADES_API:`${environment.platformApiURL}/ags-bff/grades`,
}